import React from 'react';
import { LayoutGrid, AppWindow, Bell, Plug, Command } from 'lucide-react';
import './ToolkitSection.scss';

const ToolkitSection = () => {
  return (
    <section className="toolkit-section">
      <div className="toolkit-container">
        <div className="toolkit-header">
          <h2 className="title">
            Everything your investments need —<br />
            finally in one place
          </h2>
          <p className="subtitle">
            Financial management and visibility in one place. Bring together insights, execution, and control into a single powerful platform — designed to simplify complexity and accelerate decision-making.
          </p>
        </div>

        <div className="toolkit-grid">
          {/* Top Row: 3 Cards */}
          <div className="toolkit-card">
            <div className="icon-wrapper icon-blue">
              <LayoutGrid size={20} />
            </div>
            <h3 className="card-title">Insights at your fingertips</h3>
            <p className="card-desc">
              All your data and finances in one place to provide quick answers and make decisions instantly.
            </p>
          </div>

          <div className="toolkit-card">
            <div className="icon-wrapper icon-green">
              <AppWindow size={20} />
            </div>
            <h3 className="card-title">Manage in real time</h3>
            <p className="card-desc">
              Have full control of your business finances on the go using our Android mobile apps. Because, you know, it's 2025.
            </p>
          </div>

          <div className="toolkit-card">
            <div className="icon-wrapper icon-orange">
              <Bell size={20} />
            </div>
            <h3 className="card-title">Important technical alerts</h3>
            <p className="card-desc">
              Advanced indicators (ATR, ADX, momentum oscillators) provide actionable trading signals. Real-time technical alerts notify of critical chart patterns and breakout opportunities.
            </p>
          </div>

          {/* Bottom Row: 2 Cards */}
          <div className="toolkit-card bottom-card">
            <div className="icon-wrapper icon-purple">
              <Plug size={20} />
            </div>
            <h3 className="card-title">Connect all your brokers</h3>
            <p className="card-desc">
              Seamlessly connect all your brokerage accounts and have a unified portfolio tracking.
            </p>
          </div>

          <div className="toolkit-card bottom-card">
            <div className="icon-wrapper icon-pink">
              <Command size={20} />
            </div>
            <h3 className="card-title">Interact with our AI Agents</h3>
            <p className="card-desc">
              Test your custom trading strategies conversationally. Automatically fetch historical data and calculate indicators. Deliver comprehensive risk-adjusted performance.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ToolkitSection;
